module.exports = __webpack_public_path__ + "static/quiz_thumbnail_12-4496df022cf3f0f35d3e82b205267a24.jpg";